import React from "react";
import Account from "./Account";
import Deposits from "./Deposits";
import Borrow from "./Borrow";

const AssetsAccount = () => {
  return (
    <div className="px-7 2xl:pr-7 2xl:pl-0">
      <Account />
      <Deposits />
      <Borrow />
    </div>
  );
};

export default AssetsAccount;
